import React, { useEffect, useState } from "react";
import { brand } from "../../../context";
import { useQuery } from "@tanstack/react-query";
import { getQuotations } from "../../../api/quotation";
import { useApoAuth } from "../../../hooks";
import { DateTime } from "luxon";

export const Quotations = () => {
  const [token, setToken] = useState(null);
  const { getIdTokenClaims, source_entity, user } = useApoAuth();

  // Get and set token
  useEffect(() => {
    getIdTokenClaims().then((data) => setToken(data.__raw));
  }, []);

  const { data } = useQuery({
    queryKey: ["myquotations", token],
    queryFn: () =>
      getQuotations({ token, params: { source_entity, creator: user?.sub } }),
    enabled: !!token,
    refetchOnWindowFocus: false,
  });
  const quotations = data?.data?.results ?? [];

  return (
    <div className="Card Quotations" data-brand={brand}>
      <div className="Card__header">
        <h5>My Quotations</h5>
      </div>
      <div className="Card__body Quotations__body">
        <table
          className="Table Quotations__body__mobiletable"
          data-brand={brand}>
          <thead>
            <tr>
              <th>#</th>
              <th>Reference</th>
              <th>Title</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {quotations.map((q, idx) => {
              return (
                <tr>
                  <td>{idx + 1}</td>
                  <td>{q?.reference}</td>
                  <td>{q?.title || "N/A"}</td>
                  <td>
                    {!!q?.offer_reference ? (
                      <button
                        className="Button"
                        data-brand={brand}
                        onClick={() => {
                          const url = `https://travelcompanion.easytravel.tech/trip_info/REF__${q.offer_reference}`;
                          window.open(url, "_blank") ||
                            window.location.replace(url);
                        }}>
                        View Offer
                      </button>
                    ) : (
                      q.status_display
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <table
          className="Table Quotations__body__desktoptable"
          data-brand={brand}>
          <thead>
            <tr>
              <th>#</th>
              <th>Title</th>
              <th>Pax</th>
              <th>Trip Start Date</th>
              <th>Created</th>
              <th>Due Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {quotations.map((q, idx) => {
              const adts = q?.adults ?? 0;
              const chd = q?.children ?? 0;
              return (
                <tr>
                  <td>{idx + 1}</td>
                  <td>{q?.title || "N/A"}</td>
                  <td>
                    {adts} {adts > 1 ? "Adults" : "Adult"}
                    {chd > 0 && `, ${chd}`}{" "}
                    {chd > 1 ? "Children" : chd > 0 && "Child"}
                  </td>
                  <td>
                    {DateTime.fromISO(q.trip_start_date).toLocaleString(
                      DateTime.DATE_MED_WITH_WEEKDAY
                    )}
                  </td>
                  <td>
                    {DateTime.fromISO(q.created).toLocaleString(
                      DateTime.DATETIME_MED_WITH_WEEKDAY
                    )}
                  </td>
                  <td>
                    {DateTime.fromISO(q.due_date).toLocaleString(
                      DateTime.DATETIME_MED_WITH_WEEKDAY
                    )}
                  </td>
                  <td>
                    {!!q?.offer_reference
                      ? "Offer Available"
                      : q.status_display}
                  </td>
                  <td>
                    {!!q?.offer_reference && (
                      <button
                        className="Button"
                        data-brand={brand}
                        onClick={() => {
                          const url = `https://travelcompanion.easytravel.tech/trip_info/REF__${q.offer_reference}`;
                          window.open(url, "_blank") ||
                            window.location.replace(url);
                        }}>
                        View Offer
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
Quotations.propTypes = {};
